import { formatDateFromSF } from "@/helpers";

export function formatPublication(item) {
  const date = formatDateFromSF(item.Fecha__c);
  return {
    autor: item.Autor_Reportero__r?.Name,
    ...item,
    date,
    timestamp: date?.getTime() || 0,
  };
}

export function preparePublications(publications = {}) {
  for (let key in publications) {
    publications[key] = formatPublication(publications[key]);
  }
  return publications;
}
